import { createSelector } from '@reduxjs/toolkit';
import { IRisk } from 'src/common/interfaces/risk.interface';
import type { TRootState } from 'src/store/store-types';

const selectRisks = (state: TRootState) => state.entities.risks;

export const selectRisksList = createSelector([selectRisks], (risks) => risks.list);

export const selectRisksByType = createSelector([selectRisksList, (_entities, type) => type], (risksList, type) =>
  risksList.filter((risk: IRisk) => risk.type === type),
);
